import { useMemo, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { FHSkeletonLoader, FHPagination } from '../../base';
import CardSkeletonLoader from './CardSkeletonLoader';
import SessionNoteItem from './SessionNoteItem';
import { FORTA_BLUE } from '../../../utils/colors';

import type { ISessionMinified } from '../../../utils/types';

const SlideChunkSize = 8;

interface EditsRequestedSessionNotesProps {
  sessions: ISessionMinified[];
  loading: boolean;
}

function EditsRequestedSessionNotes(props: EditsRequestedSessionNotesProps) {
  const { sessions, loading } = props;
  const [currentPage, setCurrentPage] = useState(1);

  const chunkedArray = useMemo(() => {
    if (!sessions) return [];

    const group = [];
    for (let i = 0; i < sessions.length; i += SlideChunkSize) {
      group.push(sessions.slice(i, i + SlideChunkSize));
    }
    return group;
  }, [sessions]);

  const handlePageChange = (_: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  return (
    <>
      {loading ? (
        <FHSkeletonLoader height={24} width={300} sx={{ mb: 2 }} />
      ) : (
        sessions.length > 0 && (
          <Typography textAlign="left" color={FORTA_BLUE.primary} ml={2} mb={2}>{`You have ${
            sessions.length
          } ${sessions.length > 1 ? 'reviews' : 'review'} in-progress`}</Typography>
        )
      )}
      <Box sx={{ flexGrow: 1 }}>
        {loading ? (
          <Grid container spacing={{ xs: 0.5, sm: 2, md: 2 }}>
            {[...Array(SlideChunkSize)].map((_, index) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3} mb={1}>
                <CardSkeletonLoader supervisionLoader />
              </Grid>
            ))}
          </Grid>
        ) : sessions.length > 0 ? (
          <>
            <Grid container spacing={{ xs: 0.5, sm: 2, md: 2 }}>
              {chunkedArray[currentPage - 1]?.map((session) => (
                <Grid key={session.id} item xs={12} sm={6} md={4} lg={3} mb={1}>
                  <SessionNoteItem session={session} cqaReviewCard />
                </Grid>
              ))}
            </Grid>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
                <FHSkeletonLoader height={24} width={120} sx={{ mb: 2 }} />
              </Box>
            ) : (
              chunkedArray.length > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
                  <FHPagination
                    count={chunkedArray.length}
                    currentPage={currentPage}
                    handlePageChange={handlePageChange}
                  />
                </Box>
              )
            )}
          </>
        ) : (
          <Typography ml={2} textAlign="left">
            There is no review in progress.
          </Typography>
        )}
      </Box>
    </>
  );
}

export default EditsRequestedSessionNotes;
